// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2i1BW","col":"styles_col__2hzj2"};